import { render, staticRenderFns } from "./CustomOrMarketplaceCards.vue?vue&type=template&id=52316499&scoped=true"
import script from "./CustomOrMarketplaceCards.vue?vue&type=script&lang=js"
export * from "./CustomOrMarketplaceCards.vue?vue&type=script&lang=js"
import style0 from "./CustomOrMarketplaceCards.vue?vue&type=style&index=0&id=52316499&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52316499",
  null
  
)

export default component.exports